<template>
  <div class="wrapper">
    <div>
      <h2 class="title">新增开屏广告</h2>
    </div>
    <!--基本信息-->
    <div class="item-container">
      <h4 class="item-title">基本信息</h4>
      <div class="item-content-container">
        <div class="left-name">开屏名称:</div>
        <el-input
          class="input-content"
          v-model="title"
          type="text"
          placeholder="请输入操作口令"
        />
      </div>
      <div class="item-content-container">
        <div class="left-name">产品:</div>
        <el-select
          class="select-content"
          v-model="appName"
          placeholder="请选择"
        >
          <el-option
            v-for="item in apps"
            :key="item.appId"
            :label="item.appName"
            :value="item.appName"
          >
          </el-option>
        </el-select>
      </div>
      <div class="item-content-container">
        <div class="left-name">平台:</div>
        <el-select
          class="select-content"
          v-model="platform"
          placeholder="请选择"
        >
          <el-option
            v-for="item in platforms"
            :key="item.value"
            :label="item.value"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="item-content-container">
        <div class="left-name">渠道:</div>
        <el-select
          class="select-content"
          v-model="channel"
          placeholder="请选择"
        >
          <el-option
            v-for="item in channels"
            :key="item.value"
            :label="item.value"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <!--条件设置-->
    <div class="item-container">
      <h4 class="item-title">条件设置</h4>
      <div class="item-content-container">
        <div class="left-name">版本区间:</div>
        <div class="version-content-container">
          <input class="version-input" v-model="startAppVersion" type="text" />
          <div style="margin-inline: 10px">--</div>
          <input class="version-input" v-model="endAppVersion" type="text" />
        </div>
      </div>
      <div class="item-content-container">
        <div class="left-name">生效时间:</div>
        <div class="version-content-container">
          <date-picker v-model="beginTime"></date-picker>
          <div style="margin-inline: 10px">--</div>
          <date-picker v-model="endTime"></date-picker>
        </div>
      </div>
      <div class="item-content-container">
        <div class="left-name">展示时间:</div>
        <input class="display-input" v-model="displayTime" type="text" />秒
      </div>
      <div class="item-content-container">
        <div class="left-name">权重:</div>
        <input class="weight-input" v-model="weight" type="text" />
      </div>
    </div>
    <!--跳转信息-->
    <div class="item-container">
      <h4 class="item-title">跳转信息</h4>
      <div class="item-content-container">
        <div class="left-name">scheme:</div>
        <input
          class="input-content"
          id="ad-title-input"
          v-model="scheme"
          type="text"
        />
      </div>
    </div>
    <!--开屏图片-->
    <div class="item-container">
      <h4 class="item-title">开屏图片</h4>
      <div class="item-content-container">
        <el-table :data="picturesTables" ref="multipleTable">
          <el-table-column label="图片">
            <template #default="scope">
              <el-image :src="scope.row.url" />
            </template>
          </el-table-column>
          <el-table-column prop="resolution" label="分辨率"></el-table-column>
          <el-table-column prop="form" label="格式"></el-table-column>
          <el-table-column prop="operation" label="操作">
            <template #default="scope">
              <el-upload
                action="#"
                show-file-list
                :limit="1"
                :auto-upload="false"
                :on-change="
                  (file) => {
                    onFileChange(file, scope.$index);
                  }
                "
                :multiple="false"
              >
                <el-button size="small" type="primary">图片上传</el-button>
              </el-upload>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-button type="primary" class="submit" @click="submit">提交</el-button>
  </div>
</template>

<script>
import datePicker from 'vuejs-datepicker'
import { upload } from '../network/Network.js'
export default {
  components: {
    datePicker
  },
  props: {},
  data () {
    return {
      apps: [
        {
          appId: 'vK62wKvl',
          appName: '洪恩识字'
        },
        {
          appId: 'bMNFgdvy',
          appName: '书单'
        }
      ],
      appName: '洪恩识字',
      platforms: [
        {
          value: 'android'
        },
        {
          value: 'ios'
        }
      ],
      channels: [
        {
          value: 'huawei'
        },
        {
          value: 'ios'
        }
      ],
      picturesTables: [
        {
          url: null,
          resolution: '横版分辨率',
          form: 'png、jpg',
          operation: '上传图片'
        },
        {
          url: '',
          resolution: '竖版分辨率',
          form: 'png、jpg',
          operation: '上传图片'
        }
      ],
      title: '开屏广告',
      platform: 'android',
      channel: 'huawei',
      startAppVersion: '1.0.0',
      endAppVersion: '2.0.0',
      beginTime: new Date(),
      endTime: new Date(),
      displayTime: 5,
      weight: 10,
      scheme: 'fs:account/logout',
      landscapeImageFile: null,
      portraitImageFile: null
    }
  },
  created () {},
  mounted () {},
  watch: {},
  computed: {},
  methods: {
    submit () {
      if (this.title === '') {
        alert('开屏名称不能为空')
        return
      }
      if (this.platform === '') {
        alert('平台不能为空')
        return
      }
      if (this.startAppVersion === '') {
        alert('开始版本号不能为空')
        return
      }
      if (this.startAppVersion === '') {
        alert('开始版本号不能为空')
        return
      }
      let appId = ''
      this.apps.forEach((item, index) => {
        if (item.appName === this.appName) {
          appId = item.appId
        }
      })
      if (appId === '') {
        alert('产品不能为空')
        return
      }
      let beginTime = this.beginTime.getTime()
      if (beginTime === null) {
        alert('开始时间不能为空')
        return
      }
      let endTime = this.endTime.getTime()
      if (beginTime === null) {
        alert('结束时间不能为空')
        return
      }
      if (this.displayTime === null) {
        alert('展示时间不能为空')
        return
      }
      if (this.scheme === '') {
        alert('sheme不能为空')
        return
      }
      if (this.landscapeImageFile === null || this.portraitImageFile === null) {
        alert('请选择图片')
        return
      }
      upload(
        {
          landscapeImageFile: this.landscapeImageFile,
          portraitImageFile: this.portraitImageFile
        },
        'http://39.96.15.187:8060/web/ad/create_ad',
        {
          title: this.title,
          appId: appId,
          platform: this.platform,
          startAppVersion: this.startAppVersion,
          endAppVersion: this.endAppVersion,
          beginTime: beginTime,
          endTime: endTime,
          displayTime: parseInt(this.displayTime),
          weight: parseInt(this.weight),
          scheme: this.scheme,
          channel: this.channel
        },
        function (err, data) {
          if (err) {
            alert(err)
          } else {
            alert('create success')
          }
        }
      )
    },
    onFileChange (file, index) {
      if (file.status === 'ready') {
        let raw = file.raw
        if (index === 0) {
          this.landscapeImageFile = raw
        } else if (index === 1) {
          this.portraitImageFile = raw
        }
        this.picturesTables[index].url = URL.createObjectURL(raw)
      }
    }
  }
}
</script>
<style scoped>
.wrapper {
  margin: 40px;
  text-align: left;
}
.title {
  text-align: left;
}
.item-container {
  margin-top: 30px;
}
.item-content-container {
  display: flex;
  margin-top: 20px;
  align-items: center;
}
.item-title {
  text-align: left;
}
.left-name {
  width: 80px;
  text-align: right;
  margin-right: 15px;
}
.input-content {
  width: 400px;
  height: 28px;
}
.select-content {
  width: 410px;
}
.version-content-container {
  display: flex;
  align-items: center;
}
.version-input {
  width: 180px;
  height: 28px;
}
.display-input {
  width: 180px;
  height: 28px;
  margin-right: 5px;
}
.weight-input {
  width: 180px;
  height: 28px;
}
.submit {
  width: 100px;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/module/ad/Ad.vue